import { FormControl, InputLabel } from '@material-ui/core';
import React from 'react';

import { currencyFormat } from 'utils/currencyFormat';
import Budget from 'entities/budget/model';
import { BudgetTotals } from 'containers/DonationRulesListPage/utils';

interface Props {
  budget: Budget;
  budgetTotals: BudgetTotals;
  budgetInactive: boolean;
}

export const DonationGivingRulesVolunteerRewardDonationSummary = ({
  budget,
  budgetTotals,
  budgetInactive,
}: Props) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 15,
      opacity: budgetInactive ? 0.5 : 1,
    }}
  >
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Used</InputLabel>
      </FormControl>
      <div>
        {currencyFormat(budgetTotals.totalVolunteerRewardDonations, budget.get('currencyCode'))}
      </div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Balance</InputLabel>
      </FormControl>
      <div>
        {Number.isFinite(budgetTotals.totalVolunteerRewardDonationsAllocationBalance)
          ? currencyFormat(
              budgetTotals.totalVolunteerRewardDonationsAllocationBalance,
              budget.get('currencyCode')
            )
          : '-'}
      </div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Allocated</InputLabel>
      </FormControl>
      <div>
        {currencyFormat(
          budgetTotals.totalVolunteerRewardDonationsAllocation,
          budget.get('currencyCode')
        )}
      </div>
    </div>
    <div style={{ width: '20%' }} />
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Donation Count</InputLabel>
      </FormControl>
      <div>{budgetTotals.volunteerRewardDonationsCount}</div>
    </div>
  </div>
);

export default DonationGivingRulesVolunteerRewardDonationSummary;
